import { useParams } from "react-router";
import { useSelector } from "@jti/store";
export const useMinimumPayableAmount = () => {
    const { orderId } = useParams();
    const { value: cartGrandTotalValue = 0 } = useSelector((state) => state.cart?.prices.data?.grandTotal) ?? {};
    const { value: minimumPayableAmountValue = 0 } = useSelector((state) => state.cart.minimumPayableAmount) ?? {};
    if (orderId) {
        return { isReached: false };
    }
    return { isReached: cartGrandTotalValue < minimumPayableAmountValue };
};
//# sourceMappingURL=useMinimumPayableAmount.js.map